package games.polyclub.website.frontend.store.hooks

import games.polyclub.website.frontend.store.context.AuthContext
import react.useContext

fun useAuth() = checkNotNull(useContext(AuthContext)) {
    "AuthContext indisponível"
}
